import(/* webpackMode: "eager" */ "/src/app/contribuer/page.tsx");
